import { memo } from "react";
import type { BatchJobPanelProps } from "../../batch_job_kind_contract";
import { PubmedIngestPanelBody } from "./PubmedIngestPanelBody";
import { usePubmedIngestPanel } from "./usePubmedIngestPanel";

/** Results panel for a pubmed_ingest batch job. */
export const PubmedIngestPanel = memo(function PubmedIngestPanel({
  job,
  onJobChanged,
}: BatchJobPanelProps) {
  const panel = usePubmedIngestPanel(job, onJobChanged);
  return <PubmedIngestPanelBody panel={panel} />;
});
